<div class="npdc-title">
  <h1>Permissions - {{ dataset().content.title }}</h1>
  <div class="npdc-title__actions">
    @if (selectedPermission()) {
      <button mat-flat-button (click)="edit()">Edit</button>
      <button mat-button (click)="delete()">Delete</button>
    } @else {
      <button mat-flat-button (click)="edit()">Add</button>
    }
    <a mat-button type="button" routerLink="/dataset/{{ dataset().id }}">Close</a>
  </div>
</div>

<ul>
  <li>
    <b>Reader</b> - This user can access the dataset description and download the associated files
    before the dataset has been published. This role can be used to grant access to people who might
    need to review the dataset description and files prior to final publication.
  </li>
  <li>
    <b>Contributor</b> - In addition to full read access this user can make changes to the dataset
    metadata and upload new data files to the dataset.
  </li>
  <li>
    <b>Owner</b> - This user has access to all dataset functionality, this means they can read,
    update and delete the dataset and any of its files as long as the dataset hasn't been published.
    Users with this role can grant dataset access to other registered users. This role is
    automatically assigned to the dataset creator.
  </li>
</ul>
<mat-selection-list [multiple]="false">
  @for (permission of permissions(); track permission.userId; let isLast = $last) {
    <mat-list-option
      togglePosition="before"
      [value]="permission.userId"
      [selected]="selectedPermission()?.userId === permission.userId"
      (click)="
        selectedPermission()?.userId === permission.userId
          ? selectedPermission.set(null)
          : selectedPermission.set(permission)
      "
    >
      <span matListItemTitle>{{ (permission.userId | resolveUser | async)?.email }}</span>
      <span matListItemLine><b>Role</b>: {{ permission | roleString }}</span>
      <span matListItemLine><b>ID</b>: {{ permission.userId }}</span>
    </mat-list-option>
  }
</mat-selection-list>

<mat-paginator
  showFirstLastButtons
  (page)="page.set($event)"
  [length]="count()"
  [pageIndex]="page().pageIndex"
  [pageSize]="page().pageSize"
  [pageSizeOptions]="[10, 20, 50, 100]"
>
</mat-paginator>
